import React from 'react';
import './MinimizeButton.scss';

type MinimizeButtonProps = {
    onClick: () => void;
};

/**
 * The minimise affordance for a modal header's `close` slot: a `btn-close` button whose
 * default "×" glyph is swapped for a minus icon and whose accessible name is "Minimize".
 * Collapses a modal to a restorable indicator without dismissing it — pass it as
 * `<ModalHeader close={<MinimizeButton onClick={...} />}>`. The rules every minimisable
 * modal follows are in PanelSite.md "Minimisable modals".
 */
export default class MinimizeButton extends React.Component<MinimizeButtonProps> {
    render() {
        return (
            <button
                type="button"
                className="btn-close minimizeButton"
                aria-label="Minimize"
                onClick={this.props.onClick}
            >
                <i className="icon ion-md-remove" aria-hidden="true"></i>
            </button>
        );
    }
}
